/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_Preview_Chat_5Inputs */



/**
* | output |
* | --- |
* | "Santi's product sync notes" |
*
* @param {Sidebar_Preview_Chat_5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sidebar_preview_chat_5 = /** @type {((inputs?: Sidebar_Preview_Chat_5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Preview_Chat_5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Santis Produkt-Sync-Notizen")
	return /** @type {LocalizedString} */ ("Santi's product sync notes")
});